<template>
  <div class="ScaryModal" v-show="state.show">
    <div class="ScaryModal__backdrop"></div>
    <div class="ScaryModal__content box">
      {{ state.message }}
      <hr />
      <div class="buttons between">
        <button
          class="button is-danger"
          :class="state.loading ? 'is-loading' : ''"
          @click="act"
        >
          Valider
        </button>
        <button
          class="button is-light"
          :disabled="state.loading"
          @click="purge"
        >
          Annuler
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { SCARY_MODAL } from "../store/actions/actions";

const BaseModalState = () => ({
  loading: false,
  show: false,
  message: "",
  action: () => {}
});

export default {
  name: "PhilCollins",
  data() {
    return {
      state: BaseModalState()
    };
  },
  methods: {
    act() {
      this.state.loading = true;
      this.state.action().then(() => {
        setTimeout(() => {
          this.purge();
        }, 1200);
      });
    },
    purge() {
      this.state = BaseModalState();
    }
  },
  mounted() {
    this.$root.$on(SCARY_MODAL, ({ message, action }) => {
      this.state.message = message;
      this.state.action = action;
      this.state.show = true;
    });
  }
};
</script>

<style lang="scss">
.ScaryModal {
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &__backdrop {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  &__content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 560px;
  }
  .between {
    display: flex;
    justify-content: space-between;
  }
}
</style>
